// import axios from "axios";
// import { toast } from "react-hot-toast";

// const BASE_URL = process.env.REACT_APP_API_BASE_URL;

// /* ================================
//    ACTION TYPES
// ================================ */
// export const FETCH_KITCHEN_SURVEY_LIST_REQUEST =
//   "FETCH_KITCHEN_SURVEY_LIST_REQUEST";
// export const FETCH_KITCHEN_SURVEY_LIST_SUCCESS =
//   "FETCH_KITCHEN_SURVEY_LIST_SUCCESS";
// export const FETCH_KITCHEN_SURVEY_LIST_FAILURE =
//   "FETCH_KITCHEN_SURVEY_LIST_FAILURE";

// export const FETCH_KITCHEN_SURVEY_DETAIL_REQUEST =
//   "FETCH_KITCHEN_SURVEY_DETAIL_REQUEST";
// export const FETCH_KITCHEN_SURVEY_DETAIL_SUCCESS =
//   "FETCH_KITCHEN_SURVEY_DETAIL_SUCCESS";
// export const FETCH_KITCHEN_SURVEY_DETAIL_FAILURE =
//   "FETCH_KITCHEN_SURVEY_DETAIL_FAILURE";

// export const FETCH_KITCHEN_USER_SURVEY_LIST_REQUEST =
//   "FETCH_KITCHEN_USER_SURVEY_LIST_REQUEST";
// export const FETCH_KITCHEN_USER_SURVEY_LIST_SUCCESS =
//   "FETCH_KITCHEN_USER_SURVEY_LIST_SUCCESS";
// export const FETCH_KITCHEN_USER_SURVEY_LIST_FAILURE =
//   "FETCH_KITCHEN_USER_SURVEY_LIST_FAILURE";

// /* ================================
//    KITCHEN USER SURVEY LIST
//    /kitchen/usersurveyList
// ================================ */
// export const fetchKitchenUserSurveyList = () => async (dispatch) => {
//   dispatch({ type: FETCH_KITCHEN_USER_SURVEY_LIST_REQUEST });

//   try {
//     const res = await axios.get(
//       `${BASE_URL}/api/maa_canteen/kitchen/usersurveyList`,
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           Accept: "application/json",
//         },
//       }
//     );

//     dispatch({
//       type: FETCH_KITCHEN_USER_SURVEY_LIST_SUCCESS,
//       payload: res.data.data,
//     });

//     return res.data.data;
//   } catch (error) {
//     dispatch({
//       type: FETCH_KITCHEN_USER_SURVEY_LIST_FAILURE,
//       payload: error.message,
//     });

//     toast.error("Failed to fetch kitchen user survey list");
//     throw error;
//   }
// };

// /* ================================
//    KITCHEN SURVEY DETAIL
//    /user-survey/kitchen/:id
// ================================ */
// export const fetchKitchenSurveyDetail = (surveyId) => async (dispatch) => {
//   dispatch({ type: FETCH_KITCHEN_SURVEY_DETAIL_REQUEST });

//   try {
//     const res = await axios.get(
//       `${BASE_URL}/api/maa_canteen/user-survey/kitchen/${surveyId}`,
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           Accept: "application/json",
//         },
//       }
//     );

//     dispatch({
//       type: FETCH_KITCHEN_SURVEY_DETAIL_SUCCESS,
//       payload: res.data.data,
//     });

//     return res.data.data;
//   } catch (error) {
//     dispatch({
//       type: FETCH_KITCHEN_SURVEY_DETAIL_FAILURE,
//       payload: error.message,
//     });

//     toast.error("Failed to fetch kitchen survey detail");
//     throw error;
//   }
// };

// /* ================================
//    KITCHEN SURVEY ID LIST
//    /user-survey-list/kitchen
// ================================ */
// export const fetchKitchenSurveyList = () => async (dispatch) => {
//   dispatch({ type: FETCH_KITCHEN_SURVEY_LIST_REQUEST });

//   try {
//     const res = await axios.get(
//       `${BASE_URL}/api/maa_canteen/user-survey-list/kitchen`,
//       {
//         headers: {
//           Authorization: `Bearer ${localStorage.getItem("token")}`,
//           Accept: "application/json",
//         },
//       }
//     );

//     dispatch({
//       type: FETCH_KITCHEN_SURVEY_LIST_SUCCESS,
//       payload: res.data.data,
//     });

//     return res.data.data;
//   } catch (error) {
//     dispatch({
//       type: FETCH_KITCHEN_SURVEY_LIST_FAILURE,
//       payload: error.message,
//     });

//     toast.error("Failed to fetch kitchen survey list");
//     throw error;
//   }
// };

import axios from "axios";
import { toast } from "react-hot-toast";

const BASE_URL = process.env.REACT_APP_API_BASE_URL;

/* ================================
   ACTION TYPES
================================ */
export const FETCH_KITCHEN_SURVEY_LIST_REQUEST =
  "FETCH_KITCHEN_SURVEY_LIST_REQUEST";
export const FETCH_KITCHEN_SURVEY_LIST_SUCCESS =
  "FETCH_KITCHEN_SURVEY_LIST_SUCCESS";
export const FETCH_KITCHEN_SURVEY_LIST_FAILURE =
  "FETCH_KITCHEN_SURVEY_LIST_FAILURE";

export const FETCH_KITCHEN_SURVEY_DETAIL_REQUEST =
  "FETCH_KITCHEN_SURVEY_DETAIL_REQUEST";
export const FETCH_KITCHEN_SURVEY_DETAIL_SUCCESS =
  "FETCH_KITCHEN_SURVEY_DETAIL_SUCCESS";
export const FETCH_KITCHEN_SURVEY_DETAIL_FAILURE =
  "FETCH_KITCHEN_SURVEY_DETAIL_FAILURE";

export const FETCH_KITCHEN_USER_SURVEY_LIST_REQUEST =
  "FETCH_KITCHEN_USER_SURVEY_LIST_REQUEST";
export const FETCH_KITCHEN_USER_SURVEY_LIST_SUCCESS =
  "FETCH_KITCHEN_USER_SURVEY_LIST_SUCCESS";
export const FETCH_KITCHEN_USER_SURVEY_LIST_FAILURE =
  "FETCH_KITCHEN_USER_SURVEY_LIST_FAILURE";

/* ================================
   KITCHEN USER SURVEY LIST
   /kitchen/usersurveyList
   This returns ALL kitchen surveys for the user with full details
================================ */
export const fetchKitchenUserSurveyList = () => async (dispatch) => {
  dispatch({ type: FETCH_KITCHEN_USER_SURVEY_LIST_REQUEST });

  try {
    const res = await axios.get(
      `${BASE_URL}/api/maa_canteen/kitchen/usersurveyList`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      }
    );

    dispatch({
      type: FETCH_KITCHEN_USER_SURVEY_LIST_SUCCESS,
      payload: res.data.data,
    });

    return res.data.data;
  } catch (error) {
    dispatch({
      type: FETCH_KITCHEN_USER_SURVEY_LIST_FAILURE,
      payload: error.message,
    });

    toast.error("Failed to fetch kitchen user survey list");
    throw error;
  }
};

/* ================================
   KITCHEN SURVEY DETAIL
   /user-survey/kitchen/:id
================================ */
export const fetchKitchenSurveyDetail = (surveyId) => async (dispatch) => {
  dispatch({ type: FETCH_KITCHEN_SURVEY_DETAIL_REQUEST });

  try {
    const res = await axios.get(
      `${BASE_URL}/api/maa_canteen/user-survey/kitchen/${surveyId}`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
      }
    );

    dispatch({
      type: FETCH_KITCHEN_SURVEY_DETAIL_SUCCESS,
      payload: res.data.data,
    });

    return res.data.data;
  } catch (error) {
    dispatch({
      type: FETCH_KITCHEN_SURVEY_DETAIL_FAILURE,
      payload: error.message,
    });

    toast.error("Failed to fetch kitchen survey detail");
    throw error;
  }
};

/* ================================
   KITCHEN SURVEY ID LIST (Filtered by canteen)
   /user-survey-list/kitchen?canteen_id=xxx
================================ */
export const fetchKitchenSurveyList = (params = {}) => async (dispatch) => {
  dispatch({ type: FETCH_KITCHEN_SURVEY_LIST_REQUEST });

  try {
    const res = await axios.get(
      `${BASE_URL}/api/maa_canteen/user-survey-list/kitchen`,
      {
        headers: {
          Authorization: `Bearer ${localStorage.getItem("token")}`,
          Accept: "application/json",
        },
        params: params // Pass parameters like canteen_id
      }
    );

    dispatch({
      type: FETCH_KITCHEN_SURVEY_LIST_SUCCESS,
      payload: res.data.data,
    });

    return res.data.data;
  } catch (error) {
    dispatch({
      type: FETCH_KITCHEN_SURVEY_LIST_FAILURE,
      payload: error.message,
    });

    toast.error("Failed to fetch kitchen survey list");
    throw error;
  }
};